// Central brand constants for INFLOW Marketing (Inflow Agency).
export const BRAND_NAME = "INFLOW Marketing";
export const BRAND_FOUNDER = "Faisal Mangal";
export const BRAND_LOCATION = "Houston, Texas, USA";
export const BRAND_SITE = "https://apply.inflow-agency.com";
export const BRAND_LOGO_URL =
  "https://assets.cdn.filesafe.space/5WS7iGuKlqV8edmNNswQ/media/41d8899f-c1f3-4192-9aca-dd8ed31b6ab7.png";
export const BRAND_COPYRIGHT = "© Inflow Agency, 2025 / All Rights Reserved";
export const BRAND_META_DESCRIPTION =
  "See How We Average 15-30 NEW QUALIFIED APPOINTMENTS Per Location A Month For Our Clients";
export const BRAND_META_KEYWORDS =
  "Spinal Decompression, Regen, Knee Pain, Neuropathy";
